import { FIND_PARAMETERS, UPDATE_PARAMETERS } from './../constants';
import { handleActions } from "redux-actions"

export const parameters  = handleActions(
  {
    // [ FETCH_USER ]: (state, action) => action.payload || action.payload.data[0]
    [ FIND_PARAMETERS ]: (state, action) => action.payload,
    [ UPDATE_PARAMETERS ]: (state, action) => {
      // console.log('UPDATE_PARAMETERS', action)
      const result  = action.payload
      const { id } = result
          const prevState  = state
          const initialValue = []
          const newParameter = prevState.reduce((acc, parameter) => {
              if (parameter.id === id) {
                // console.log(parameter.id +  ' con ' + id)
                  return [...acc, result]
              } else {
                  return [...acc, parameter]
              }
          }, initialValue)
          return newParameter
  },
  }, []
)